import Vue from 'vue'
import CONFIG from '~config/env'
import DynamicCacheControl from '~services/DynamicCacheControl'
import { Promise } from 'es6-promise'

const auth = new Vue({
  data: function () {
    return {
      whitelabel: {}
    }
  }
})

const whitelabelCache = () => {
  return DynamicCacheControl.getInstance('whitelabel')
}

const loadWhitelabel = organizationId => {
  setWhitelabel({})
  return Promise.resolve(auth.$data.whitelabel)
  // if (Vue.isOnline) {
  //   if (organizationId) {
  //     return WhitelabelService.getWhitelabelByOrganization(organizationId).then(whitelabel => {
  //       setWhitelabel(whitelabel.data.results[0])
  //       return auth.$data.whitelabel
  //     })
  //   }
  //   return WhitelabelService.getWhitelabel(document.location.hostname).then(whitelabel => {
  //     setWhitelabel(whitelabel.data.results[0])
  //     return auth.$data.whitelabel
  //   })
  // } else {
  //   return whitelabelCache()
  //     .getItem(document.location.hostname)
  //     .then(whitelabel => {
  //       if (!whitelabel) {
  //         if (organizationId) {
  //           return WhitelabelService.getWhitelabelByOrganization(organizationId).then(whitelabel => {
  //             setWhitelabel(whitelabel.data.results[0])
  //             return auth.$data.whitelabel
  //           })
  //         }
  //         return WhitelabelService.getWhitelabel(document.location.hostname).then(whitelabel => {
  //           setWhitelabel(whitelabel.data.results[0])
  //           return auth.$data.whitelabel
  //         })
  //       }
  //       setWhitelabel(whitelabel)
  //       return auth.$data.whitelabel
  //     })
  // }
}

const getDefaultOptions = whitelabel => {
  whitelabel = whitelabel || {}
  whitelabel.custom_domain = whitelabel.custom_domain || CONFIG.WHITELABEL_DEFAULTS.DOMAIN
  whitelabel.email_from = whitelabel.email_from || CONFIG.WHITELABEL_DEFAULTS.EMAIL_FROM
  whitelabel.organization_id = whitelabel.organization_id || CONFIG.WHITELABEL_DEFAULTS.ORGANIZATION_ID
  whitelabel.ui_customizations = whitelabel.ui_customizations || {}

  whitelabel.ui_customizations.title = whitelabel.ui_customizations.title || CONFIG.WHITELABEL_DEFAULTS.TITLE

  whitelabel.ui_customizations.primaryColor = whitelabel.ui_customizations.primaryColor || CONFIG.WHITELABEL_DEFAULTS.PRIMARY_COLOR
  whitelabel.ui_customizations.secondaryColor = whitelabel.ui_customizations.secondaryColor || CONFIG.WHITELABEL_DEFAULTS.SECONDARY_COLOR
  whitelabel.ui_customizations.accentColor = whitelabel.ui_customizations.accentColor || CONFIG.WHITELABEL_DEFAULTS.ACCENT_COLOR

  whitelabel.ui_customizations.darkIcons = whitelabel.ui_customizations.darkIcons || CONFIG.WHITELABEL_DEFAULTS.DARK_ICONS

  whitelabel.ui_customizations.mainLogo = whitelabel.ui_customizations.mainLogo || CONFIG.WHITELABEL_DEFAULTS.MAIN_LOGO
  whitelabel.ui_customizations.navLogo = whitelabel.ui_customizations.navLogo || CONFIG.WHITELABEL_DEFAULTS.NAV_LOGO
  whitelabel.ui_customizations.webappLogo = whitelabel.ui_customizations.webappLogo || CONFIG.WHITELABEL_DEFAULTS.WEBAPP_LOGO
  whitelabel.ui_customizations.webappLogo512 = whitelabel.ui_customizations.webappLogo512 || CONFIG.WHITELABEL_DEFAULTS.WEBAPP_LOGO_512
  whitelabel.ui_customizations.favLogo = whitelabel.ui_customizations.favLogo || CONFIG.WHITELABEL_DEFAULTS.FAV_LOGO
  whitelabel.ui_customizations.loginBackgroundImage =
    whitelabel.ui_customizations.loginBackgroundImage || CONFIG.WHITELABEL_DEFAULTS.LOGIN_BACKGROUND_IMAGE
  whitelabel.ui_customizations.disableHelp = whitelabel.ui_customizations.disableHelp || false
  return whitelabel
}

const setWhitelabel = whitelabel => {
  whitelabel = getDefaultOptions(whitelabel)
  auth.$data.whitelabel = whitelabel
  whitelabelCache().setItem(document.location.hostname, whitelabel)

  document.title = whitelabel.ui_customizations.title
  document.querySelector('#dynamic-apple-mobile-web-app-title').setAttribute('content', whitelabel.ui_customizations.title)
  changeFavIcon(whitelabel.ui_customizations.favLogo.fullPath)
  changeManifestJson(whitelabel)
  changeHomeScreenLogos(whitelabel.ui_customizations.webappLogo.fullPath)
  if (Vue.prototype.$vuetify) {
    Vue.prototype.$vuetify.theme.primary = whitelabel.ui_customizations.primaryColor
    Vue.prototype.$vuetify.theme.secondary = whitelabel.ui_customizations.secondaryColor
    Vue.prototype.$vuetify.theme.accent = whitelabel.ui_customizations.accentColor
  }
}

const persistWhitelabel = whitelabel => {
  if (whitelabel.custom_domain === CONFIG.WHITELABEL_DEFAULTS.DOMAIN && Vue.currentOrganization.id !== CONFIG.WHITELABEL_DEFAULTS.ORGANIZATION_ID) {
    return Promise.reject('whitelabel.before_customize_set_your_custom_domain')
  }

  // if (whitelabel.id) {
  //   return WhitelabelService.updateWhitelabel(whitelabel).then(whitelabel => {
  //     setWhitelabel(whitelabel.data)
  //     return auth.$data.whitelabel
  //   })
  // } else {
  //   return WhitelabelService.createWhitelabel(whitelabel).then(whitelabel => {
  //     setWhitelabel(whitelabel.data)
  //     return auth.$data.whitelabel
  //   })
  // }
}

const getWhitelabelUI = uiResource => {
  const whitelabel = auth.$data.whitelabel || {}
  whitelabel.ui_customizations = whitelabel.ui_customizations || {}
  return whitelabel.ui_customizations[uiResource]
}

const changeFavIcon = src => {
  document.head || (document.head = document.getElementsByTagName('head')[0])

  const link = document.createElement('link')
  const oldLink = document.getElementById('dynamic-favicon')
  link.id = 'dynamic-favicon'
  link.rel = 'shortcut icon'
  link.href = src

  if (oldLink) {
    document.head.removeChild(oldLink)
  }
  document.head.appendChild(link)
}

const changeHomeScreenLogos = src => {
  document.querySelector('#dynamic-msapplication-TileImage').setAttribute('content', src)
  document.querySelector('#dynamic-apple-touch-icon').setAttribute('href', src)
  document.querySelector('#dynamic-mask-icon').setAttribute('href', src)
}

const changeManifestJson = whitelabel => {
  const myDynamicManifest = {
    name: whitelabel.ui_customizations.title,
    short_name: whitelabel.ui_customizations.title,
    description: 'Plataforma de Regularização de Fundiária',
    icons: [
      {
        src: whitelabel.ui_customizations.webappLogo.fullPath,
        sizes: '192x192',
        type: 'image/png'
      },
      {
        src: whitelabel.ui_customizations.webappLogo512.fullPath,
        sizes: '512x512',
        type: 'image/png'
      }
    ],
    screenshots: [
      {
        src: '/screenshots/desktop_01.png',
        sizes: '2860x1548',
        type: 'image/png',
        form_factor: 'wide'
      },
      {
        src: '/screenshots/desktop_02.png',
        sizes: '2860x1548',
        type: 'image/png',
        form_factor: 'wide'
      },
      {
        src: '/screenshots/mobile_01.png',
        sizes: '628x1360',
        type: 'image/png',
        form_factor: 'narrow'
      },
      {
        src: '/screenshots/mobile_02.png',
        sizes: '628x1360',
        type: 'image/png',
        form_factor: 'narrow'
      }
    ],
    start_url: '/',
    scope: '/',
    display: 'standalone',
    background_color: '#FFFFFF',
    theme_color: whitelabel.ui_customizations.primaryColor
  }

  const stringManifest = JSON.stringify(myDynamicManifest)
  const blob = new Blob([stringManifest], { type: 'application/javascript' })
  const manifestURL = URL.createObjectURL(blob)
  document.querySelector('#dynamic-manifest').setAttribute('href', manifestURL)
}

export default {
  install(Vue) {
    Vue.prototype.$setWhitelabel = Vue.setWhitelabel = setWhitelabel

    // Reactive Getters
    Object.defineProperty(Vue.prototype, '$whitelabel', {
      get: () => {
        return auth.$data.whitelabel
      }
    })

    Object.defineProperty(Vue, 'whitelabel', {
      get: () => {
        return auth.$data.whitelabel
      }
    })

    Object.defineProperty(Vue.prototype, '$loadWhitelabel', {
      get: () => {
        return loadWhitelabel
      }
    })

    Object.defineProperty(Vue, 'loadWhitelabel', {
      get: () => {
        return loadWhitelabel
      }
    })

    Object.defineProperty(Vue.prototype, '$persistWhitelabel', {
      get: () => {
        return persistWhitelabel
      }
    })

    Object.defineProperty(Vue, 'persistWhitelabel', {
      get: () => {
        return persistWhitelabel
      }
    })

    Object.defineProperty(Vue.prototype, '$getWhitelabelUI', {
      get: () => {
        return getWhitelabelUI
      }
    })

    Object.defineProperty(Vue, 'getWhitelabelUI', {
      get: () => {
        return getWhitelabelUI
      }
    })
  }
}
